import { render } from "./AccountsBanks.vue?vue&type=template&id=5af0d24c&scoped=true"
import script from "./AccountsBanks.vue?vue&type=script&lang=js"
export * from "./AccountsBanks.vue?vue&type=script&lang=js"

import "./AccountsBanks.vue?vue&type=style&index=0&id=5af0d24c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af0d24c"]])

export default __exports__